/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import List, { ListItem } from '../../../../components/List';
import { NoCardsPaddedContent } from '../../../../components/PaddedContent';
import ContentWrapper from '../../../../components/ContentWrapper';
import GroupSunset from '../../../../components/GroupSunset';

const SearchResults = (props) => {
  if (props.isSearching) {
    return <div />;
  } else if (props.results.length > 0) {
    return (
      <ContentWrapper>
        <GroupSunset/>
        <List hasBorder hasRoundedWrapper paddingSize="default">
          {
            props.results.map((result, index) => (
              <ListItem
                key={index}
                onClick={() => props.onSelectResult(result)}
                style={{ paddingTop: 18, paddingBottom: 18 }}
                disabled={props.isDisabled(result)}
              >
                {props.renderResult(result)}
              </ListItem>
            ))
          }
        </List>
      </ContentWrapper>
    );
  } else {
    return (
      <NoCardsPaddedContent>
        {props.emptyContent}
      </NoCardsPaddedContent>
    );
  }
};
SearchResults.propTypes = {
  results: PropTypes.array,
  onSelectResult: PropTypes.func,
  emptyContent: PropTypes.any,
  isSearching: PropTypes.bool,
  renderResult: PropTypes.func,
  isDisabled: PropTypes.func,
};

export default SearchResults;
